import React, { memo, useEffect } from 'react'
import { makeStyles } from '@material-ui/styles'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { TextField, Editor, FeaturedMedia, Tags } from './components'
import styles from './styles'
import { useArticleState } from '../../reducer'
import { EArticleSectionTypes } from 'models'
import { scrollTopContainer } from 'utils'

const useStyles = makeStyles(styles)

const Body: React.FunctionComponent<{}> = () => {
	const classes = useStyles()
	const { t } = useTranslation()
	const [state] = useArticleState()

	const { section, error, tags } = state

	useEffect(() => {
		if (
			(error?.title || error?.featuredImage || error?.featureVideo) &&
			section === 'article'
		) {
			const container = document.getElementById('editor-container')
			scrollTopContainer(container)
		}
	}, [error, section])

	return (
		<div className={classes.container}>
			<div
				id="editor-container"
				style={{
					display: 'flex',
					flexDirection: 'column',
				}}
			>
				<FeaturedMedia />
				{section === EArticleSectionTypes.article && (
					<TextField
						name={'title'}
						placeholder={t('Article title')}
						className={classNames(classes.titleEditor, {
							[classes.textError]: error.title,
						})}
					/>
				)}
				<Editor />
			</div>
			{section === EArticleSectionTypes.article && (
				<div className={classes.teaserContainer}>
					<TextField
						name={'description'}
						placeholder={t('Describe your post in a sentence, to give a relevant sneak peack')}
						className={classNames(classes.teaserInput, {
							[classes.textError]: error.description,
						})}
					/>
				</div>
			)}
			<Tags selected={tags} />
		</div>
	)
}

export default memo(Body)
